<template>
  <v-container class="my-0 ml-0 mr-n2 pa-0" fluid>
    <v-row density="compact" class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-2">
        <p>Configure agents to run on a recurring schedule. Results will be delivered via email.</p>
      </v-col>
    </v-row>
    <v-row density="compact" class="ma-0 pa-0">
      <v-col cols="12" density="compact" class="ma-0 pa-2 d-flex align-center">
        <Button buttonClass="ml-1" icon="mdi-plus" v-if="filteredRunIds.length > 0" :click="addNewSchedule" size="x-large" tooltip="New Schedule" variant="outlined" density="default" color="secondary"></Button>
        <!-- Add sorting and filtering controls here, similar to Agents.vue -->
        <v-spacer></v-spacer>
        <v-tooltip text="Refresh Scheduled Runs" location="top">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" color="primary" variant="text" icon :loading="refreshingSchedules" @click="refreshSchedules">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row density="compact" class="ma-0 pa-0">
      <v-col v-for="runId in filteredRunIds" :key="runId" cols="12" class="ma-0 pa-2" density="compact">
        <ScheduledRunCard :id="runId" @remove-card="removeNewScheduleCard" />
      </v-col>
      <v-col v-if="count === 0" cols="12" md="6" xl="4" class="ma-0 pa-2">
        <v-card @click="addNewSchedule" class="ma-0 pa-2 card add-card" color="surface" density="compact" variant="elevated" elevation="4" min-height="350">
          <p>New Schedule</p>
          <v-icon class="add-icon" icon="mdi-plus"></v-icon>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'
import Button from '@/components/sub/Button.vue'
import ScheduledRunCard from '@/components/cards/ScheduledRunCard.vue'
import { ScheduledRun } from '@/types/schedules'

@Options({
  components: {
    Button,
    ScheduledRunCard,
  },
  computed: {
    ...mapGetters(['scheduledRunsList'])
  },
  watch: {
    scheduledRunsList: {
      handler() {
        this.filterRuns()
      },
      deep: true
    }
  }
})
export default class Schedules extends mixins(AnalyticsMixin) {
  scheduledRunsList!: ScheduledRun[]
  filteredRunIds: string[] = []
  count = 0
  refreshingSchedules = false
  // Add search and sortOrder data properties

  mounted() {
    this.filterRuns()
    this.trackComponentView('schedules_tab', {
      scheduled_run_count: this.count
    })
  }

  async refreshSchedules() {
    if (this.refreshingSchedules) return
    this.trackButtonClick('refresh_schedules', 'click', {
      scheduled_run_count: this.count
    })
    this.refreshingSchedules = true
    try {
      await this.$store.dispatch('fetchScheduledRuns')
    } finally {
      this.refreshingSchedules = false
    }
  }

  filterRuns() {
    if (!this.scheduledRunsList) {
      this.filteredRunIds = []
      this.count = 0
      return
    }
    // Implement filtering and sorting logic here
    this.filteredRunIds = this.scheduledRunsList.map(run => run.id)
    // Add the empty card if it exists
    if (this.filteredRunIds.includes('')) {
      const index = this.filteredRunIds.indexOf('')
      this.filteredRunIds.splice(index, 1)
      this.filteredRunIds.unshift('')
    }
    this.count = this.scheduledRunsList.length
  }

  addNewSchedule() {
    this.trackButtonClick('create_schedule_start', 'click', {
      scheduled_run_count: this.count
    })
    // Add an empty string to render a new card for creation
    if (!this.filteredRunIds.includes('')) {
      this.filteredRunIds.unshift('')
      this.count++
    }
  }

  removeNewScheduleCard() {
    const index = this.filteredRunIds.indexOf('')
    if (index > -1) {
      this.filteredRunIds.splice(index, 1)
      this.count--
    }
  }
}
</script>
<style scoped lang="scss">
.add-card {
  border: 1px solid rgba(255, 255, 255, 0.3);
  height: 350px;
  text-align: center;
  cursor: pointer;

  p {
    margin-top: 130px;
  }
}

.add-card-small {
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-align: center;
  cursor: pointer;
}
</style>
